'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = {
  container: {
    '@media (max-width: 767px)': {
      height: 'auto'
    }
  },
  title: {
    height: '40px',
    marginBottom: '10px',
    fontSize: '22px',
    display: 'flex',
    alignItems: 'center',
    textTransform: 'uppercase',
    '@media (max-width: 767px)': {
      color: '#0096ff',
      justifyContent: 'flex-start'
    }
  },
  box: {
    '@media (max-width: 767px)': {
      opacity: 1,
      transform: 'none',
      marginTop: 0
    }
  },
  img: {
    display: 'block',
    width: '300px',
    height: '150px',
    '@media (max-width: 767px)': {
      width: '250px',
      height: '125px'
    }
  },
  boxContent: {
    boxSizing: 'border-box',
    width: '300px',
    padding: '25px 25px 30px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '1px 0px 6px 1px #ddd',
    '@media (max-width: 767px)': {
      width: '250px',
      padding: '20px 15px 25px'
    }
  },
  boxParagraph: {
    marginBottom: '15px',
    fontFamily: 'Helvetica Neue',
    fontWeight: 400,
    fontSize: '16px',
    color: '#4a494b',
    '@media (max-width: 767px)': {
      fontSize: '14px',
      marginBottom: '0'
    }
  }
};

var Element = function (_React$Component) {
  _inherits(Element, _React$Component);

  function Element(props) {
    _classCallCheck(this, Element);

    return _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));
  }

  _createClass(Element, [{
    key: 'render',
    value: function render() {
      var elementPosition = this.props.number % 2 === 0 ? {
        justifyContent: 'flex-start'
      } : {
        justifyContent: 'flex-end'
      };
      return _react2["default"].createElement('div', {
        'data-aos': 'expand',
        'data-aos-offset': 300,
        style: styles.container
      }, _react2["default"].createElement('div', {
        'data-aos': 'blue-text',
        'data-aos-offset': 300,
        style: [elementPosition, styles.title]
      }, this.props.title), _react2["default"].createElement('div', {
        'data-aos': 'zoom-in-up',
        'data-aos-offset': 250,
        style: styles.box
      }, _react2["default"].createElement('img', {
        src: this.props.imgUrl,
        style: styles.img,
        alt: this.props.title
      }), _react2["default"].createElement('div', {
        style: styles.boxContent
      }, _react2["default"].createElement('div', {
        style: styles.boxParagraph
      }, this.props.paragraph))));
    }
  }]);

  return Element;
}(_react2["default"].Component);

var component = (0, _radium2["default"])(Element);
exports["default"] = {
  component: component
};